import { render, staticRenderFns } from "./AdminSystemNotificationForm.vue?vue&type=template&id=19d7353c&"
import script from "./AdminSystemNotificationForm.vue?vue&type=script&lang=js&"
export * from "./AdminSystemNotificationForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports